export const SERVICES = {
    PROVISION: 'provision',
    SCHEDULE: 'schedule',
    ENLIGHTEN: 'enlighten',
    SCANDIT: 'scanditKey',
    HEMS: 'hems',
    HOMECONNECT: 'homeconnect',
    API: 'api',
    SITEDEVICE: 'siteDevice'
}
